import _ from "lodash";

export default advancedSearchObject => {
  let queryParams = "";

  _.forEach(advancedSearchObject, object => {
    // format of filters -> filter[role_id]=id1
    queryParams += `&filter[${object.id}]=${encodeURIComponent(
      object.keyword
    )}`;
  });

  return queryParams;
};



// WEBPACK FOOTER //
// ./src/utils/parseAdvancedSearch.js